import React, { useState, useEffect } from 'react';
import "./Myinformation.css";
import MyInfoPassword from "../MyInfoPassword/MyInfoPassword";
import { checkUser, checkUserEdit } from "../../../api/admin/adminApi"; // ✅ API import (경로 맞게 수정)
import Checkbox from '@mui/material/Checkbox';
import { pink } from '@mui/material/colors';

const Myinformation = () => {
  const [userData, setUserData] = useState({
    userId: "",
    name: "",
    tel: "",
    privacyConsent: false,
    marketingConsent: false,
  });
  const [isPasswordOpen, setIsPasswordOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  // ✅ 사용자 정보 불러오기
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await checkUser();
        if (res?.data) {
          const data = res.data;
          setUserData({
            userId: data.userId || "",
            name: data.name || "",
            tel: data.tel || "",
            privacyConsent: data.privacyConsent || false,
            marketingConsent: data.marketingConsent || false,
          });
        }
      } catch (error) {
        console.error("유저 정보 불러오기 실패:", error);
      }
    };
    fetchUser();
  }, []);

  // ✅ input 변경 핸들러
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ 체크박스 변경 핸들러
  const handleCheckboxChange = (field, value) => {
    setUserData((prev) => ({ ...prev, [field]: value }));
  };

  // ✅ 저장 버튼 클릭 시
  const handleSave = async () => {
    try {
      const res = await checkUserEdit(userData);
      alert("수정이 완료되었습니다.");
      console.log("수정 결과:", res);
      setIsEditing(false);
    } catch (error) {
      alert("정보 수정 중 오류가 발생했습니다.");
      console.error("정보 수정 실패:", error);
    }
  };

  // ✅ 취소 버튼 클릭 시
  const handleCancel = () => {
    setIsEditing(false);
    window.location.reload(); // 초기화용
  };

  return (
    <div className='Myinformation_Container'>
      <div className='Myinformation_TitleBox'>내정보</div>

     
      {/* 이름 */}
      <div className='Myinformation_NameContainer'>
        <div className='Myinformation_NameBox'>이름</div>
        <input
          type='text'
          className='Myinformation_NameTextFelid'
          name='name'
          value={userData.name}
          onChange={handleChange}
        />
      </div>

      {/* 이름 */}
      <div className='Myinformation_NameContainer'>
        <div className='Myinformation_NameBox'>이메일</div>
        <input
          type='text'
          className='Myinformation_NameTextFelid'
          name='userId'
          value={userData.userId}
          onChange={handleChange}
        />
      </div>

      {/* 전화번호 */}
      <div className='Myinformation_NameContainer'>
        <div className='Myinformation_NameBox'>전화번호</div>
        <input
          type='text'
          className='Myinformation_NameTextFelid'
          name='tel'
          value={userData.tel}
          onChange={handleChange}
        />
      </div>

      {/* 비밀번호 변경 버튼 */}
      <div
        className='Myinformation_PasswordChangeBtn'
        onClick={() => setIsPasswordOpen(!isPasswordOpen)}
        style={{
          cursor: "pointer",
          color: "#9D91FF",
          margin: "10px 0",
          textAlign: "center",
        }}
      >
        비밀번호 변경
      </div>

      {/* ✅ 비밀번호 변경 모달 */}
      {isPasswordOpen && (
        <div className="PopupContainer">
          <MyInfoPassword onClose={() => setIsPasswordOpen(false)} />
        </div>
      )}

      {/* 개인정보 / 마케팅 동의 */}
      <div className='Myinformation_AgreeContainer'>
        <div style={{display:'flex'}}>
          개인정보 동의 여부
          <div style={{display:'flex'}}>
            <div className='custom-checkbox-wrapper'>
              <label className='custom-checkbox'>
                <input type='checkbox' checked={userData.privacyConsent===true} onChange={()=>
                handleCheckboxChange("privacyConsent", !userData.privacyConsent)
                }
                style={{opacity:"0", width:"0.1px"}}
                />
                <span className='checkmark' />

              </label>
              동의
            </div>

            <div className='custom-checkbox-wrapper'>
              <label className='custom-checkbox'>

                <input type='checkbox' checked={userData.privacyConsent===false} onChange={()=>
                handleCheckboxChange("privacyConsent", false)
                } style={{opacity:"0", width:"0.1px"}}/>
                <span className='checkmark' />

              </label>
              미동의
            </div>
            {/* <input type="radio" checked={!privacyConsent} onChange={()=> setPrivacyConsent(false)}
            /> */}

          </div>
        </div>

        <div style={{display:'flex'}}>
        마케팅 동의 여부
          <div style={{display:'flex'}}>
            <div className='custom-checkbox-wrapper'>
              <label className='custom-checkbox'>
                <input type='checkbox' checked={userData.marketingConsent===true}
                 onChange={()=>
                  handleCheckboxChange("marketingConsent", !userData.marketingConsent)
                  } style={{opacity:"0", width:"0.1px"}}
                />
                <span className='checkmark' />

              </label>
              동의
            </div>

            <div className='custom-checkbox-wrapper'>
              <label className='custom-checkbox'>

                <input type='checkbox' checked={userData.marketingConsent===false} onChange={()=>
                  handleCheckboxChange("marketingConsent", false)
                  } style={{opacity:"0", width:"0.1px"}}/>
                <span className='checkmark' />

              </label>
              미동의
            </div>
            {/* <input type="radio" checked={!privacyConsent} onChange={()=> setPrivacyConsent(false)}
            /> */}

          </div>
        </div>
</div>

      {/* 버튼 */}
      <div className='Myinformation_BtnContainer'>
        <div
          className='Myinformation_Btn'
          onClick={handleSave}
          
        >
          저장
        </div>
        <div
          className='Myinformation_Btn'
          onClick={handleCancel}
        >
          취소
        </div>
      </div>
    </div>
  );
};

export default Myinformation;
